import {UiState} from './types';
import {ActionReducerMapBuilder} from '@reduxjs/toolkit';

export const extraReducers = (builder: ActionReducerMapBuilder<UiState>) => {
  // builder.addCase(someAction.matcher, someAction.reducer);
};
